<script setup>
import { reactive, toRefs, ref } from "vue";
import { xhlzxOrderPage } from "@/api/order/order";
import moment from "moment/moment";
// 添加防抖搜索
import { debounce } from 'lodash-es';

const debounceSearch = debounce(() => {
  searchEvent();
}, 300);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const statusList = ref([
  { id: 1, name: "已支付" },
  { id: 0, name: "待支付" },
  { id: 2, name: "已退款" },
]);
const state = reactive({
  active: 0,
  empty: false,
  show: false,
  searchData: {
    patientNameLike: "",
    status: 2,
    pageNum: 1,
    pageSize: 10,
    startDate: moment(new Date()).format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  orderData: [],
  orderList: [],
  dateTime: new Date(),
  minDate: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
});

// 上拉加载
const onLoad = () => {
  xhlzxOrderPage(Object.assign(state.searchData)).then((v) => {
    const { data } = v;
    if (refreshing.value) {
      state.orderList = [];
      refreshing.value = false;
    }
    if (data.records.length) {
      state.searchData.pageNum++;
      state.orderList.push(...data.records);
      state.orderData = [...state.orderList];
      loading.value = false;
    } else {
      finished.value = true;
      state.orderData = [...state.orderList];
      loading.value = false;
    }
    // state.orderData = state.orderList;
  });
};
// 下拉刷新
const onRefresh = () => {
  state.searchData.pageNum = 1;
  state.orderList = [];
  state.orderData = [];
  // 清空列表数据
  finished.value = false;
  loading.value = true;
  onLoad();
};
onRefresh();
// 选择状态
const onClickTab = (val) => {
  state.searchData.pageNum = 1;
  // 建议优化为更清晰的映射关系
  const statusMap = {
    0: 2, // 待支付
    1: 1, // 已支付
    2: 3  // 已退款
  };
  state.searchData.status = statusMap[val];
  state.orderList = [];
  state.orderData = [];
  finished.value = false;   // 重置完成状态
  loading.value = true;
  onLoad();
};

const onConfirm = (date) => {
  state.dateTime = date;
  state.searchData.pageNum = 1;
  state.orderList = [];
  state.orderData = [];
  state.searchData.startDate = moment(date).format("YYYY-MM-DD");
  state.searchData.endDate = moment(date).format("YYYY-MM-DD");
  state.show = false;
  finished.value = false;
  loading.value = true;
  onLoad();
};
// 搜索框
const searchEvent = () => {
  state.searchData.pageNum = 1;
  state.orderList = [];
  state.orderData = [];
  finished.value = false;
  loading.value = true;
  onLoad();
};
const clearEvent = () => {
  state.searchData.patientNameLike = "";
  state.searchData.pageNum = 1;
  state.orderList = [];
  state.orderData = [];
  finished.value = false;
  loading.value = true;
  onLoad();
};
const { active, show, searchData } = toRefs(state);
</script>
<template>
  <div class="content">
    <van-nav-bar>
      <template #left>
        <van-icon name="search" size="18" />
        <van-cell-group inset>
          <van-field style="border: none" v-model="searchData.patientNameLike" rows="1" autosize type="textarea"
            placeholder="请输入姓名" @update:model-value="debounceSearch" @clear="clearEvent" clearable>
            <template #button>
              <!-- <a
                @click="clearEvent"
                style="color: #1989fa"
                size="small"
                type="primary"
              >
                重置
              </a> -->
            </template>
          </van-field>
        </van-cell-group>
      </template>
      <template #right>
        <span v-if="state.dateTime" @click="show = true">
          {{ $moment(state.dateTime).format("YYYY-MM-DD") }}</span>
      </template>
    </van-nav-bar>
    <van-calendar :min-date="state.minDate" v-model:show="show" @confirm="onConfirm" />
    <van-tabs color="#1989fa" @change="onClickTab" v-model:active="active">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-tab v-for="status in statusList" :key="status.id" :title="status.name">
          <van-list v-if="state.orderData.length" v-model:loading="loading" :finished="finished" finished-text="没有更多了"
            @load="onLoad">
            <van-row v-for="item in state.orderData" :key="item.id" class="card">
              <van-col span="6" class="title"> {{ item.patientName }} </van-col>
              <van-col span="12" class="title" style="text-align: center">
                {{ item.patientDeptName }}
              </van-col>
              <van-col span="6" class="amount title">
                {{ item.productAmount }}元
              </van-col>
              <van-col span="16">
                缴费编号：{{ item.medicalAdviceCode }}
              </van-col>
              <van-col span="24">
                缴费时间：
                <span v-if="item.payeeTime">
                  {{ $moment(item.payeeTime).format("YYYY-MM-DD HH:mm:ss") }}
                </span>
              </van-col>
              <van-col style="
                  margin-top: 5px;
                  background: #f5f5f5;
                  border-radius: 4px;
                  padding: 2px 0;
                " span="24">
                <van-row style="
                    border-bottom: 1px solid #dcdada;
                    padding: 2px 8px;
                    margin-bottom: 4px;
                  ">
                  <van-col span="19" style="color: #999">
                    <span style="font-size: 14px !important; font-weight: bold">
                      产品名称
                    </span>
                  </van-col>
                  <van-col span="5" style="color: #999; text-align: right">
                    <span style="font-size: 14px !important; font-weight: bold">
                      数量
                    </span>
                  </van-col>
                  <!-- <van-col span="5" class="amount title"> 单价 </van-col> -->
                  <!-- <van-col span="5" class="amount title"> 总价 </van-col> -->
                </van-row>
                <van-row style="padding: 0 8px" v-for="goods in item.goodses" :key="goods.id">
                  <van-col span="19">
                    {{ goods.productName }}
                  </van-col>
                  <van-col span="5" class="amount">
                    {{ `${goods.goodsQuantity} ${goods.goodsUnitName}` }}
                  </van-col>
                  <!-- <van-col span="5" class="amount">
                    ￥{{ goods.goodsUnitPrice }}
                  </van-col> -->
                  <!-- <van-col span="5" class="amount">
                    ￥{{ goods.goodsTotalPrice }}
                  </van-col> -->
                </van-row>
              </van-col>
            </van-row>
          </van-list>
          <van-empty v-else style="height: 90vh"
            image="https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png" image-size="80"
            description="暂无数据" />
        </van-tab>
      </van-pull-refresh>
    </van-tabs>
  </div>
</template>
<style lang="scss">
.content {
  background: #f5f5f5;
  height: 100vh;
  overflow: hidden;

  .van-swipe__track {
    transform: none !important;
  }

  .van-nav-bar__left {
    width: 70%;
  }

  .van-cell-group {
    width: 100%;
  }

  .van-tabs__content {
    overflow-y: scroll;
  }

  .van-list {
    height: auto !important;
  }

  .van-pull-refresh {
    height: 90vh;
    overflow: auto !important;
  }

  .card {
    border-radius: 10px;
    margin: 10px;
    background: #fff;
    padding: 10px;
    line-height: 2;

    .title {
      font-weight: bold;
      font-size: 16px;
    }

    .amount {
      text-align: right;
    }
  }
}
</style>
